module.exports = __webpack_public_path__ + "static/img/empty_data.a8ddaf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/empty_data.png
// module id = d2T1
// module chunks = 0